module.exports = require("@bechtel/client-assets/dist/images/arc-stryker-black-logo.svg");